const ADD_MONEY_DELINK_WALLET_PREFIX = "ad-mn-del";

export const ADD_MONEY_DELINK_WALLET_DATA_TEST_IDS = {
    CONTAINER: `${ADD_MONEY_DELINK_WALLET_PREFIX}_container`,
    HEADER_TITLE: `${ADD_MONEY_DELINK_WALLET_PREFIX}_header_title`,
    WALLET_ICON: `${ADD_MONEY_DELINK_WALLET_PREFIX}_wal_icn`,
    BALANCE: `${ADD_MONEY_DELINK_WALLET_PREFIX}_bal`,
    DELINK_CTA: `${ADD_MONEY_DELINK_WALLET_PREFIX}_del_cta`,
    DELINK_CONFIRMATION_PRIMARY_CTA: `${ADD_MONEY_DELINK_WALLET_PREFIX}_del_con_pri_cta`,
    DELINK_CONFIRMATION_SECONDARY_CTA: `${ADD_MONEY_DELINK_WALLET_PREFIX}_del_con_sec_cta`,
    DELINK_CONFIRMATION_TITLE: `${ADD_MONEY_DELINK_WALLET_PREFIX}_del_con_titl`,
    DELINK_FAILURE_PRIMARY_CTA: `${ADD_MONEY_DELINK_WALLET_PREFIX}_del_fai_pri_cta`,
    DELINK_FAILURE_CLOSE_CTA: `${ADD_MONEY_DELINK_WALLET_PREFIX}_del_fai_cls_cta`,
    DELINK_FAILURE_TITLE: `${ADD_MONEY_DELINK_WALLET_PREFIX}_del_fai_titl`,
    ADD_MONEY_IMPUT: `${ADD_MONEY_DELINK_WALLET_PREFIX}_ad_mn_inp`,
    ADD_MONEY_CTA: `${ADD_MONEY_DELINK_WALLET_PREFIX}_ad_mn_cta`,
    GENERIC_ERROR: `${ADD_MONEY_DELINK_WALLET_PREFIX}_gen_err`,
};
